import { useState, useEffect, useCallback } from "react";

const useFetchBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchBlogs = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);
    setError(null);

    try {
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const response = await fetch(`${baseUrl}/blogs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || "Failed to fetch blogs";
        throw new Error(message);
      }

      // Handle nested response structure: data.data.blogs
      const blogsData = data.data?.blogs || data.data || data.results || data || [];
      setBlogs(Array.isArray(blogsData) ? blogsData : []);
      return blogsData;
    } catch (err) {
      setIsError(true);
      setError(err);
      setBlogs([]);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  return { blogs, isLoading, isError, error, refetch: fetchBlogs };
};

export default useFetchBlogs;

